var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-info',{staticClass:"object-info-wrapper",attrs:{"id":_vm.objectIdentifier[1],"type":_vm.objectIdentifier[0]},on:{"updateConfig":_vm.updateConfig,"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }